module.exports = __webpack_public_path__ + "static/media/user_agreement.501f8244.htm";